import { render } from "./WeeklyPlayboyApp.vue?vue&type=template&id=c2e4c8a6&ts=true"
import script from "./WeeklyPlayboyApp.vue?vue&type=script&lang=ts"
export * from "./WeeklyPlayboyApp.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__